/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Workflow_ResultsInputs */

const en_page_title_workflow_results = /** @type {(inputs: Page_Title_Workflow_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow results`)
};

const nl_page_title_workflow_results = /** @type {(inputs: Page_Title_Workflow_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflowresultaten`)
};

/**
* | output |
* | --- |
* | "Workflow results" |
*
* @param {Page_Title_Workflow_ResultsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_workflow_results = /** @type {((inputs?: Page_Title_Workflow_ResultsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Workflow_ResultsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_workflow_results(inputs)
	return en_page_title_workflow_results(inputs)
});